import React, { useState, useEffect } from "react";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import "../../Styles/globalStyle.css";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function Line(props) {
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();

  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  return (
  
    <div
      draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      onClick={props.onClick}
      style={buildStyle(props.style)}
      className={props.isSelected ? "lineSelected" : "line"}
      id={props.data.id}>
      
    </div>
    
  );
}
